<template>
  <div class="official-account-page">
    <header class="oa-header">
      <van-icon name="arrow-left" class="back-button" @click="goBack" />
      <span>关注公众号</span>
    </header>

    <main class="oa-card">
      <div class="oa-title">
        <div class="oa-icon"><van-icon name="wechat" /></div>
        <div>
          <strong>元脉健康</strong>
          <small>业务员服务平台</small>
        </div>
      </div>

      <div class="oa-step">
        <span class="step-no">方式一</span>
        <div class="step-body">
          <strong>微信搜索关注</strong>
          <p>打开微信「搜一搜」，搜索公众号 <b>元脉健康</b>，点击关注。</p>
        </div>
      </div>

      <div class="oa-step">
        <span class="step-no">方式二</span>
        <div class="step-body">
          <strong>扫码关注</strong>
          <p>使用微信「扫一扫」，扫描下方二维码即可关注。</p>
        </div>
      </div>

      <div class="qr-wrap">
        <img :src="qrImage" alt="元脉健康公众号二维码" class="qr-image" />
        <p class="qr-tip">长按识别或扫码关注「元脉健康」</p>
      </div>

      <div class="oa-entry">
        <van-icon name="bookmark-o" />
        <div>
          <strong>登录入口</strong>
          <p>关注后从公众号底部菜单「业务员端」进入业务员工作台。</p>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import qrImage from "@/assets/sanGao/yuanmaiGongZhongHao.jpg";

export default {
  name: "SanGaoSalesmanOfficialAccount",
  data() {
    return {
      qrImage,
    };
  },
  methods: {
    goBack() {
      this.$router.back();
    },
  },
};
</script>

<style lang="less" scoped>
.official-account-page {
  position: relative;
  min-height: 100vh;
  padding: 0 0 32px;
  background: linear-gradient(180deg, #0874ca 0%, #4ba8e0 26%, #dff6ff 56%, #f4fafd 100%);
  color: #163b5c;
}

.oa-header {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 48px;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  text-shadow: 0 2px 6px rgba(0, 48, 113, 0.3);
}

.back-button {
  position: absolute;
  top: 50%;
  left: 14px;
  font-size: 20px;
  color: #fff;
  cursor: pointer;
  transform: translateY(-50%);
}

.oa-card {
  margin: 16px;
  padding: 22px 18px 20px;
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 8px 24px rgba(12, 91, 147, 0.12);
}

.oa-title {
  display: flex;
  align-items: center;
  padding-bottom: 16px;
  border-bottom: 1px solid #eef4f9;
}

.oa-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  margin-right: 12px;
  border-radius: 12px;
  color: #fff;
  background: linear-gradient(135deg, #27b1e9, #1979d6);
}

.oa-icon .van-icon {
  font-size: 24px;
}

.oa-title strong {
  display: block;
  font-size: 18px;
  color: #163b5c;
}

.oa-title small {
  display: block;
  margin-top: 3px;
  font-size: 11px;
  color: #7c8d9c;
}

.oa-step {
  display: flex;
  margin-top: 16px;
  padding: 12px 12px;
  border-radius: 10px;
  background: #f4fafd;
}

.step-no {
  flex: 0 0 auto;
  margin-right: 10px;
  padding: 2px 8px;
  height: 20px;
  line-height: 20px;
  border-radius: 10px;
  font-size: 11px;
  color: #1670c0;
  background: #ddf0fd;
}

.step-body strong {
  display: block;
  font-size: 14px;
  color: #163b5c;
}

.step-body p {
  margin: 4px 0 0;
  font-size: 12px;
  line-height: 1.6;
  color: #5b7488;
}

.step-body b {
  color: #168de0;
}

.qr-wrap {
  margin-top: 18px;
  padding: 12px 0 6px;
  text-align: center;
}

.qr-image {
  display: inline-block;
  width: 200px;
  height: 200px;
  border: 1px solid #eef4f9;
  border-radius: 12px;
  background: #fafdff;
}

.qr-tip {
  margin: 10px 0 0;
  font-size: 12px;
  color: #5b7488;
}

.oa-entry {
  display: flex;
  margin-top: 18px;
  padding: 12px;
  border-radius: 10px;
  color: #2b8967;
  background: #ecfaf4;
}

.oa-entry .van-icon {
  flex: 0 0 auto;
  margin-right: 10px;
  font-size: 18px;
  margin-top: 1px;
}

.oa-entry strong {
  display: block;
  font-size: 13px;
}

.oa-entry p {
  margin: 4px 0 0;
  font-size: 12px;
  line-height: 1.6;
  color: #4a7a66;
}
</style>
